const dashboardActionTypes = {
  BOTPERFORMANCE_START_FETCH: 'BOTPERFORMANCE_START_FETCH',
  FETCH_BOTPERFORMANCE_DETAILS_SUCCESS: 'FETCH_BOTPERFORMANCE_DETAILS_SUCCESS',
  BOTPERFORMANCE_SET_ERROR: 'BOTPERFORMANCE_SET_ERROR',
  FETCH_BOTPERFORMANCE_DETAILS_FAILURE: 'FETCH_BOTPERFORMANCE_DETAILS_FAILURE',
  LINEGRAPH_START_FETCH: 'LINEGRAPH_START_FETCH',
  FETCH_LINEGRAPH_DETAILS_SUCCESS: 'FETCH_LINEGRAPH_DETAILS_SUCCESS',
  LINEGRAPH_SET_ERROR: 'LINEGRAPH_SET_ERROR',
  FETCH_LINEGRAPH_DETAILS_FAILURE: 'FETCH_LINEGRAPH_DETAILS_FAILURE',
  SUNBURST_START_FETCH: 'SUNBURST_START_FETCH',
  FETCH_SUNBURST_DETAILS_SUCCESS: 'FETCH_SUNBURST_DETAILS_SUCCESS',
  SUNBURST_SET_ERROR: 'SUNBURST_SET_ERROR',
  FETCH_SUNBURST_DETAILS_FAILURE: 'FETCH_SUNBURST_DETAILS_FAILURE',
  REMOVE_SUNBURST_DATA: 'REMOVE_SUNBURST_DATA',
  REMOVE_BOTPERFORMANCE_DATA: 'REMOVE_BOTPERFORMANCE_DATA',
  REMOVE_LINEGRAPH_DATA: 'REMOVE_LINEGRAPH_DATA',
  DASHBOARD_FILTER_REQUEST: 'DASHBOARD_FILTER_REQUEST',
  DASHBOARD_FILTER_SUCCESS: 'DASHBOARD_FILTER_SUCCESS',
  DASHBOARD_FILTER_FAILURE: 'DASHBOARD_FILTER_FAILURE',
  COMPANY_ONBOARDING_LINE_GRAPH_START_FETCH: 'COMPANY_ONBOARDING_LINE_GRAPH_START_FETCH',
  FETCH_COMPANY_ONBOARDING_LINE_GRAPH_DETAILS_SUCCESS:
    'FETCH_COMPANY_ONBOARDING_LINE_GRAPH_DETAILS_SUCCESS',
  FETCH_COMPANY_ONBOARDING_LINE_GRAPH_DETAILS_FAILURE:
    'FETCH_COMPANY_ONBOARDING_LINE_GRAPH_DETAILS_FAILURE',
  BARGRAPH_START_FETCH: 'BARGRAPH_START_FETCH',
  FETCH_BARGRAPH_DETAILS_SUCCESS: 'FETCH_BARGRAPH_DETAILS_SUCCESS',
  BARGRAPH_SET_ERROR: 'BARGRAPH_SET_ERROR',
  FETCH_BARGRAPH_DETAILS_FAILURE: 'FETCH_BARGRAPH_DETAILS_FAILURE',
  SCHEDULED_PERCENTAGE_START_FETCH: 'SCHEDULED_PERCENTAGE_START_FETCH',
  FETCH_SCHEDULED_PERCENTAGE_DETAILS_SUCCESS: 'FETCH_SCHEDULED_PERCENTAGE_DETAILS_SUCCESS',
  SCHEDULED_PERCENTAGE_SET_ERROR: 'SCHEDULED_PERCENTAGE_SET_ERROR',
  FETCH_SCHEDULED_PERCENTAGE_DETAILS_FAILURE: 'FETCH_SCHEDULED_PERCENTAGE_DETAILS_FAILURE',
};

export default dashboardActionTypes;
